// extracted by mini-css-extract-plugin
export default {"home-wrapper":"main_home-wrapper__mCcqa","page-wrapper":"main_page-wrapper__NP5zu","main-header":"main_main-header__ZYFcz","page-content":"main_page-content__3brIL"};